<template>
  <div :class="channelClasses[message.channel]"><span v-html="ansiUp.ansi_to_html(message.message + '\x1b[m')"></span></div>
</template>

<script setup lang="ts">
import type { ConsoleMessage } from "@/graphql";
import { AnsiUp } from "ansi_up/ansi_up";
import { inject } from "vue";

defineProps<{
  message: ConsoleMessage;
}>();

const channelClasses: Record<string, string[]> = {
  event: [/* tw */ "text-gp-green"],
  stderr: [/* tw */ "text-gp-orange"],
};

// Use a shared AnsiUp instance provided by ConsoleBase so that ANSI color state
// (e.g. an open color sequence) carries across consecutive lines.
const ansiUp = inject<AnsiUp>("ansiUp", new AnsiUp());
</script>
